import { SingleAccordion } from "./SingleAccordion";

export default SingleAccordion;
